import { Group, Stack } from "@mantine/core"
import { Loader } from "@tfg/ui"
import { useState } from "react"

import { ExportConfigurationDto, useGetExportConfigurations } from "~/gen/api"
import { ExportRequestsTable } from "~/pages/Brand/DataTransfer/Export/ExortRequestsTable"
import { ExportConfigurationsSelect } from "~/pages/Brand/DataTransfer/Export/ExportConfigurationsSelect"
import { GenerateExportActions } from "~/pages/Brand/DataTransfer/Export/GenerateExportAction"
import { useExportRequestsQuery } from "~/pages/Brand/DataTransfer/hooks"

export const DataTransferExport = () => {
  const [selectedExportConfiguration, setSelectedExportConfiguration] =
    useState<ExportConfigurationDto | undefined>()

  const { data: exportConfigurationsQuery, isLoading } =
    useGetExportConfigurations()

  const exportRequests = useExportRequestsQuery()

  if (isLoading) return <Loader fullPage />

  return (
    <Stack>
      <Group justify="-moz-initial">
        <ExportConfigurationsSelect
          selectedExportConfiguration={selectedExportConfiguration}
          setSelectedExportConfiguration={setSelectedExportConfiguration}
          exportConfigurationsData={exportConfigurationsQuery?.data}
        />
        <GenerateExportActions
          selectedExportConfiguration={selectedExportConfiguration}
        />
      </Group>
      <ExportRequestsTable
        data={exportRequests}
        total={exportRequests.length}
      />
    </Stack>
  )
}
